import { upperFirst, camelCase } from 'lodash';

var styles = {"alignLeft":"o5-sh","textWrapNowrap":"ClnY0","alignRight":"zg-eo","alignCenter":"_2qp8l","sizeFullWidth":"gldYp","renderedInTable":"_75TDZ","sizeOriginal":"BN33q","sizeContent":"hysBQ","sizeSmall":"VpC46","sizeSmallCenter":"oJXBA","flex":"-vyjX","atomic":"_0QtCV","anchor":"XzviH","embed":"vJf7p","horizontalScrollbar":"uTER8","pluginContainerMobile":"atxSN"};

const getContainerData = (node) => {
  var _a;
  const data = `${camelCase(node.type)}Data`;
  return (_a = node == null ? void 0 : node[data]) == null ? void 0 : _a.containerData;
};
const getAlignmentClassName = (containerData = {}) => {
  const { alignment } = containerData;
  if (!alignment) {
    return "";
  }
  const key = `align${upperFirst(alignment.toLowerCase())}`;
  return styles[key];
};
const getSizeClassName = (containerData) => {
  const { width } = containerData;
  const { size } = width || {};
  if (!size) {
    return "";
  }
  const key = `size${upperFirst(camelCase(size.toLowerCase()))}`;
  return styles[key];
};
const getTextWrapClassName = (containerData = {}) => {
  const { textWrap } = containerData;
  if (textWrap) {
    return "";
  }
  return styles.textWrapNowrap;
};
const alignmentClassName = (node) => {
  return getAlignmentClassName(getContainerData(node));
};
const sizeClassName = (node) => {
  return getSizeClassName(getContainerData(node) || {});
};
const textWrapClassName = (node) => {
  return getTextWrapClassName(getContainerData(node));
};

export { getSizeClassName as a, getTextWrapClassName as b, alignmentClassName as c, sizeClassName as d, getAlignmentClassName as g, styles as s, textWrapClassName as t };
//# sourceMappingURL=getClassNames-ef08ffc2.js.map
